export default __webpack_public_path__ + "static/media/05.3a864535.jpg";